export default __webpack_public_path__ + "static/media/notify_bell.be1e6bf1.svg";